import React from "react";

/**
 * Shared Coaching Debriefing Summary markup for the coaching panel and
 * Simulation Feedback Report (on-screen / Save / Print).
 * Returns null when neither a full summary nor a skip reason is present.
 *
 * @param {"panel"|"report"} variant - panel: coaching UI styles; report: matches End Track report_item fonts/border
 * @param {string} [skipReason] - when set (and no goldenNugget), shows "not generated" backchain
 */
const DebriefSummarySection = ({
  summary,
  skipReason,
  variant = "panel",
  className,
}) => {
  const hasSummary = Boolean(summary?.goldenNugget);
  const hasSkip = Boolean(skipReason);

  if (!hasSummary && !hasSkip) {
    return null;
  }

  const isReport = variant === "report";
  const rootClass =
    className ||
    (isReport ? "report_item" : "coaching-summary");

  if (!hasSummary && hasSkip) {
    if (isReport) {
      return (
        <div className={rootClass}>
          <h2>Debrief summary not generated</h2>
          <p>{skipReason}</p>
        </div>
      );
    }
    return (
      <div className={rootClass}>
        <h3>Debrief summary not generated</h3>
        <p>{skipReason}</p>
      </div>
    );
  }

  if (isReport) {
    return (
      <div className={rootClass}>
        <h2>Coaching Debriefing Summary</h2>
        <h3>The Golden Nugget</h3>
        <p>{summary.goldenNugget}</p>
        <h3>The Frame Shift</h3>
        <p>{summary.frameShift}</p>
        <h3>Performance Wins</h3>
        <ul>
          <li>{summary.performanceWin1}</li>
          <li>{summary.performanceWin2}</li>
        </ul>
        <h3>Action Plan - System Change</h3>
        <p>{summary.actionPlanSystemChange}</p>
        <h3>Action Plan - Communication Shift</h3>
        <p>{summary.actionPlanCommunicationShift}</p>
        <h3>Action Plan - Personal Growth</h3>
        <p>{summary.actionPlanPersonalGrowth}</p>
      </div>
    );
  }

  return (
    <div className={rootClass}>
      <h3>Coaching Debriefing Summary</h3>
      <div className="coaching-summary-block">
        <h4>The Golden Nugget</h4>
        <p>{summary.goldenNugget}</p>
      </div>
      <div className="coaching-summary-block">
        <h4>The Frame Shift</h4>
        <p>{summary.frameShift}</p>
      </div>
      <div className="coaching-summary-block">
        <h4>Performance Wins</h4>
        <ul>
          <li>{summary.performanceWin1}</li>
          <li>{summary.performanceWin2}</li>
        </ul>
      </div>
      <div className="coaching-summary-block">
        <h4>Action Plan - System Change</h4>
        <p>{summary.actionPlanSystemChange}</p>
      </div>
      <div className="coaching-summary-block">
        <h4>Action Plan - Communication Shift</h4>
        <p>{summary.actionPlanCommunicationShift}</p>
      </div>
      <div className="coaching-summary-block">
        <h4>Action Plan - Personal Growth</h4>
        <p>{summary.actionPlanPersonalGrowth}</p>
      </div>
    </div>
  );
};

export default DebriefSummarySection;
